// A single, permanent placeholder organization (see
// audit-backend/server/migrations/3-create-public-organization.sql) used
// for users who have created an account but not yet completed real
// organization/billing setup. Route guards check against this id to force
// such users onto the account-setup screen before they can access
// anything else in the app. Fixed, well-known id — identical across every
// environment.
export const PUBLIC_ORGANIZATION_ID = '00000000-0000-0000-0000-000000000001';